import { Settings } from '../Settings';
import { BufferPool } from './BufferPool';
var VertexBufferWebGL = /** @class */ (function () {
    function VertexBufferWebGL(gl, numVertices, dataPerVertex) {
        this.canUnload = true;
        this._gl = gl;
        this._buffer = this._gl.createBuffer();
        this._numVertices = numVertices;
        this._dataPerVertex = dataPerVertex;
    }
    Object.defineProperty(VertexBufferWebGL, "pool", {
        get: function () {
            if (!Settings.ENABLE_BUFFER_POOLING)
                return null;
            return this._pool || (this._pool = new BufferPool(VertexBufferWebGL));
        },
        enumerable: false,
        configurable: true
    });
    VertexBufferWebGL.create = function (gl, numVertices, dataPerVertex) {
        if (!Settings.ENABLE_BUFFER_POOLING) {
            return new VertexBufferWebGL(gl, numVertices, dataPerVertex);
        }
        return this.pool.create(gl, numVertices, dataPerVertex);
    };
    VertexBufferWebGL.prototype.uploadFromArray = function (array, startVertex, numVertices) {
        this._gl.bindBuffer(this._gl.ARRAY_BUFFER, this._buffer);
        if (startVertex)
            this._gl.bufferSubData(this._gl.ARRAY_BUFFER, startVertex * this._dataPerVertex, array);
        else
            this._gl.bufferData(this._gl.ARRAY_BUFFER, array, this._gl.STATIC_DRAW);
    };
    VertexBufferWebGL.prototype.uploadFromByteArray = function (data, startVertex, numVertices) {
        this._gl.bindBuffer(this._gl.ARRAY_BUFFER, this._buffer);
        if (startVertex)
            this._gl.bufferSubData(this._gl.ARRAY_BUFFER, startVertex * this._dataPerVertex, data);
        else
            this._gl.bufferData(this._gl.ARRAY_BUFFER, data, this._gl.STATIC_DRAW);
    };
    Object.defineProperty(VertexBufferWebGL.prototype, "numVertices", {
        get: function () {
            return this._numVertices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VertexBufferWebGL.prototype, "dataPerVertex", {
        get: function () {
            return this._dataPerVertex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VertexBufferWebGL.prototype, "glBuffer", {
        get: function () {
            return this._buffer;
        },
        enumerable: false,
        configurable: true
    });
    VertexBufferWebGL.prototype.dispose = function () {
        if (Settings.ENABLE_BUFFER_POOLING && VertexBufferWebGL.pool.store(this)) {
            return;
        }
        this.unload();
    };
    VertexBufferWebGL.prototype.apply = function (gl, numVertices, dataPerVertex) {
        this._numVertices = numVertices;
        this._dataPerVertex = dataPerVertex;
    };
    VertexBufferWebGL.prototype.unload = function () {
        Settings.ENABLE_BUFFER_POOLING && VertexBufferWebGL.pool.remove(this);
        this._gl.deleteBuffer(this._buffer);
    };
    return VertexBufferWebGL;
}());
export { VertexBufferWebGL };
